import { render, staticRenderFns } from "./textComponent.vue?vue&type=template&id=76251658&"
import script from "./textComponent.vue?vue&type=script&lang=js&"
export * from "./textComponent.vue?vue&type=script&lang=js&"
import style0 from "./textComponent.vue?vue&type=style&index=0&id=76251658&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports